<template>
	
	<div class="content-area__inner content-area__list content-area__projects no-padding">
		
		<ContentAreaTitle :title="$route.meta.title">
			<template slot="actions">
				<el-button icon="el-icon-plus" @click="onClickNewProjectButton" round>New Project</el-button>
			</template>
		</ContentAreaTitle>
		
		<!--<div class="card card--border card--no-padding">-->
			<el-table v-loading="$store.getters.loading" empty-text="We have no projects!" :data="projects">
				<el-table-column label="Name" :width="320">
					<template slot-scope="scope">
						<div class="project-list__logo">
							<img v-if="scope.row.data.logo_url" :src="scope.row.data.logo_url">
							<ion-icon v-else name="image"></ion-icon>
						</div>
						<div class="project-list__name-container has-subtitle">
							<router-link class="project-list__name" :to="{ name: 'projects/project', params: { projectSlug: scope.row.slug } }">{{ scope.row.name }}</router-link>
							<p class="project-list__client">{{ scope.row.client }}</p>
						</div>
					</template>
				</el-table-column>
				<!--<el-table-column prop="client" label="Client" :width="200"></el-table-column>-->
				<el-table-column prop="description" label="Description"></el-table-column>
				<!--<el-table-column>
					<template slot-scope="scope">
						<el-button type="text" @click="onClickEditProjectButton(scope.row.data)">Edit</el-button>
					</template>
				</el-table-column>-->
			</el-table>
		<!--</div>-->
		
		<el-dialog title="New Project" :visible.sync="newProject.visible" width="30%">
			
			<el-form :model="newProject">
				<el-form-item label="Client">
					<el-select v-model="newProject.client_id" size="large" placeholder="Client" style="width: 100%">
						<el-option v-for="item in $store.state.clients" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="Project Name">
					<el-input v-model="newProject.name"></el-input>
				</el-form-item>
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="onClickNewProjectPopupButton('cancel')">Cancel</el-button>
				<el-button :loading="$store.getters.loading" type="primary" @click="onClickNewProjectPopupButton('confirm')">Save</el-button>
			</span>
			
		</el-dialog>
		
	</div>
	
</template>

<script>

	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	export default {
		
		name: "Projects",
		
		components: { ContentAreaTitle },
		
		data() {
			
			return {
				
				loadingProjects: true,
				
				newProject: {
					visible: false,
					client_id: null,
					name: "",
				},
				
			}
			
		},
		
		methods: {
			
			onClickNewProjectPopupButton(action) {
				
				if (action == "confirm") {
					
					if (!this.newProject.client_id || !this.newProject.name) {
						
						this.$message("Please fill in the required fields before adding this project.");
						
					} else {
						
						this.$store.commit("setLoading", { type: "start" });
						
						this.axios.post("projects", {
							client_id: this.newProject.client_id,
							name: this.newProject.name,
						}).then((response) => {
							if (response.statusText == "OK") {
								this.newProject.visible = false;
								this.$store.commit("setLoading", { type: "finish", message: "This project has been added." });
								this.$store.dispatch("getApiData", { key: "projects" });
							} else {
								this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while adding this project." });
							}
						}).catch((e) => {
							this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while adding this project." });
						});
						
					}
					
				} else if (action == "cancel") {
					
					this.newProject.visible = false;
					
				}
				
			},
			
			onClickNewProjectButton() {
				this.newProject.visible = true;
				this.newProject.client_id = null;
				this.newProject.name = "";
			},
			
			onClickEditProjectButton(data) {
				this.$router.push({ name: "projects/project", params: { projectSlug: data.slug } });
			},
			
		},
		
		computed: {
			projects() {
				return this.$store.state.projects.map(function(data, i) {
					return {
						id: data.id,
						name: data.name,
						client: data.client.name,
						description: data.description ? data.description : "N/A",
						slug: data.slug,
						data: data,
					};
				});
			},
		},
		
		created() {
			this.$store.dispatch("getApiData", { key: "projects" });
		},
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Projects.vue